  <div class="p-2 mobile-search">
    <ng-container *ngIf="masterData?.data?.page_info['search']">
      <app-searching
        [search_place_holder]="masterData.data.page_info['search'].searchPlaceholder"
        [focus_place_holder]="masterData.data.page_info['search'].focusSearchText">
      </app-searching>
    </ng-container>
  </div>